var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"final-score"},[_vm._v(" BT Score "+_vm._s(_vm.formattedValue)+" "),_c('span',{staticClass:"final-score-of"},[_vm._v("von 5")])])}
var staticRenderFns = []

export { render, staticRenderFns }